module.exports = __webpack_public_path__ + "img/globe.0bd34587.svg";